import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class TransportDriverBlacklist extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/driver/blackList`)
  }
}
